import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const TextWithButtonIntro = ({ blok }) => (
  <div>
    <div
      className="textwithbuttonintro-wrap flex"
      {...storyblokEditable(blok)}
    >
      <div className="textwithbuttonintro-wrap-content flex">
        <div className="textwithbuttonintro-content flex flex-col">
          <h2 className="textwithbuttonintro-subheadline text-6xl">
            {blok.subheadline}
          </h2>
          <h2 className="textwithbuttonintro-subheadlineTwo text-6xl">
            {blok.subheadline2}
          </h2>

          <div className="textwithbuttonintro-text-outer">
            <p className="textwithbuttonintro-text">{blok.text}</p>
          </div>

          <div className="textwithbuttonintro-points">
            <div className="textwithbuttonintro-point">
              <img src="/src/check_white.png" alt="" />
              <p>{blok.point1}</p>
            </div>

            <div className="textwithbuttonintro-point">
              <img src="/src/check_white.png" alt="" />

              <p>{blok.point2}</p>
            </div>

            <div className="textwithbuttonintro-point">
              <img src="/src/check_white.png" alt="" />

              <p>{blok.point3}</p>
            </div>
          </div>

          <div className="textwithbuttonintro-button">
            {blok.link && (
              <Link href={blok.link} >
                <button>{blok.button}</button>
              </Link>
            )}
            {blok.linknewtab && (
              <Link target="_blank" href={blok.linknewtab} >
                  <button>{blok.buttonnewtab}</button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TextWithButtonIntro;
